<script>
import Ajv from 'ajv'
import { firebase } from '@firebase/app'
import '@firebase/firestore'
const { Timestamp } = firebase.firestore
export default {
  schema: {
    type: 'object',
    additionalProperties: false,
    properties: {
      _nanoseconds: {
        type: 'number'
      },
      _seconds: {
        type: 'number'
      }
    }
  },
  convertJsonToTimetamp (value) {
    let ajv = new Ajv()
    let validate = ajv.compile(this.schema)
    if (validate(value)) {
      return new Timestamp(value._seconds, value._nanoseconds)
    }
    return value
  }
}
</script>
